"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _link = require("rich-text-lib/constants/link");

var _withLinkState = _interopRequireDefault(require("rich-text-lib/components/links/withLinkState"));

var _EditLinkPopoverBody = _interopRequireDefault(require("rich-text-lib/components/links/EditLinkPopoverBody"));

var _TinyMcePopover = _interopRequireDefault(require("./TinyMcePopover"));

var _usageTracking = require("../utils/usageTracking");

var ManagedLinkPopoverBody = (0, _withLinkState.default)(_EditLinkPopoverBody.default);

var LinkEditPopover =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(LinkEditPopover, _Component);

  function LinkEditPopover(props) {
    var _this;

    (0, _classCallCheck2.default)(this, LinkEditPopover);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(LinkEditPopover).call(this, props));
    _this.handleUpdate = _this.handleUpdate.bind((0, _assertThisInitialized2.default)(_this));
    _this.trackLinkUsage = _this.trackLinkUsage.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(LinkEditPopover, [{
    key: "handleUpdate",
    value: function handleUpdate(linkInfo) {
      // updating when href is '' results in the link being removed and the popover closing
      if (linkInfo.href !== '' && this.props.open) {
        this.props.onUpdate(linkInfo);
      }
    }
  }, {
    key: "trackLinkUsage",
    value: function trackLinkUsage(trackingAction, trackingValues) {
      (0, _usageTracking.trackInteraction)(this.props.editor, 'tinymceLink', trackingAction, trackingValues);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          editor = _this$props.editor,
          target = _this$props.target,
          onSelectFile = _this$props.onSelectFile,
          onRemove = _this$props.onRemove,
          onUnlink = _this$props.onUnlink,
          fetchPages = _this$props.fetchPages,
          fetchMeetings = _this$props.fetchMeetings,
          fetchAnchors = _this$props.fetchAnchors,
          fetchMeetingBySlug = _this$props.fetchMeetingBySlug,
          onClose = _this$props.onClose,
          showRefAndTargetControls = _this$props.showRefAndTargetControls,
          useEmailSubscription = _this$props.useEmailSubscription,
          allowFileDownload = _this$props.allowFileDownload,
          allowMeetingLink = _this$props.allowMeetingLink,
          allowAnchorLinks = _this$props.allowAnchorLinks,
          fetchPageBySlug = _this$props.fetchPageBySlug,
          fetchFileFromUrl = _this$props.fetchFileFromUrl,
          mode = _this$props.mode,
          updateMode = _this$props.updateMode,
          open = _this$props.open,
          cache = _this$props.cache,
          updateCache = _this$props.updateCache,
          externalLink = _this$props.externalLink,
          href = _this$props.href,
          noFollow = _this$props.noFollow,
          onAnchorPreviewClick = _this$props.onAnchorPreviewClick;
      return _react.default.createElement(_TinyMcePopover.default, {
        placement: "bottom",
        editor: editor,
        target: target,
        onRemove: onRemove,
        _useMutationObserver: true,
        open: open,
        animateOnToggle: false,
        content: _react.default.createElement(ManagedLinkPopoverBody, {
          dropdownClassName: "mce-ui-select",
          externalLink: externalLink,
          href: href,
          noFollow: noFollow,
          onUnlink: onUnlink,
          fetchPages: fetchPages,
          fetchMeetings: fetchMeetings,
          fetchAnchors: fetchAnchors,
          fetchMeetingBySlug: fetchMeetingBySlug,
          onClose: onClose,
          onSelectFile: onSelectFile,
          onUpdate: this.handleUpdate,
          showRefAndTargetControls: showRefAndTargetControls,
          useEmailSubscription: useEmailSubscription,
          allowFileDownload: allowFileDownload,
          allowMeetingLink: allowMeetingLink,
          allowAnchorLinks: allowAnchorLinks,
          fetchPageBySlug: fetchPageBySlug,
          fetchFileFromUrl: fetchFileFromUrl,
          updateMode: updateMode,
          mode: mode,
          scopes: editor.settings.scopes,
          userId: editor.settings.userId,
          cache: cache,
          updateCache: updateCache,
          trackLinkUsage: this.trackLinkUsage,
          onAnchorPreviewClick: onAnchorPreviewClick
        })
      }, children);
    }
  }]);
  return LinkEditPopover;
}(_react.Component);

exports.default = LinkEditPopover;
LinkEditPopover.propTypes = {
  children: _react.PropTypes.object.isRequired,
  editor: _react.PropTypes.object.isRequired,
  open: _react.PropTypes.bool.isRequired,
  onRemove: _react.PropTypes.func.isRequired,
  target: _react.PropTypes.instanceOf(HTMLElement).isRequired,
  href: _react.PropTypes.string.isRequired,
  onSelectFile: _react.PropTypes.func.isRequired,
  externalLink: _react.PropTypes.bool.isRequired,
  noFollow: _react.PropTypes.bool.isRequired,
  onUnlink: _react.PropTypes.func.isRequired,
  onClose: _react.PropTypes.func.isRequired,
  onUpdate: _react.PropTypes.func.isRequired,
  showRefAndTargetControls: _react.PropTypes.bool.isRequired,
  fetchPageBySlug: _react.PropTypes.func.isRequired,
  fetchPages: _react.PropTypes.func.isRequired,
  fetchMeetings: _react.PropTypes.func.isRequired,
  fetchAnchors: _react.PropTypes.func.isRequired,
  fetchMeetingBySlug: _react.PropTypes.func.isRequired,
  fetchFileFromUrl: _react.PropTypes.func.isRequired,
  cache: _react.PropTypes.object.isRequired,
  updateCache: _react.PropTypes.func.isRequired,
  useEmailSubscription: _react.PropTypes.bool,
  allowFileDownload: _react.PropTypes.bool,
  allowMeetingLink: _react.PropTypes.bool,
  allowAnchorLinks: _react.PropTypes.bool,
  mode: _react.PropTypes.oneOf([_link.EditMode.PREVIEW, _link.EditMode.EDIT]),
  updateMode: _react.PropTypes.func,
  onAnchorPreviewClick: _react.PropTypes.func
};
module.exports = exports.default;